import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    View,
    FlatList,
    TextInput,
    ScrollView,
    TouchableOpacity
} from 'react-native';

import {
    JDText,
    JDImage,
    JDLogin,
    JDConfirmDialog,
    JDAlertDialog
} from '@jdreact/jdreact-core-lib';

import Loading from '../../components/common/loading';
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';
import MovieCardItem from '../../components/movieCard/card-item';
import Error from '../../components/common/error';
import st from '../../style/movie-card/list.st';
import { Link, NavBar, Alert } from '@ltfe/ltfe-core-lib';
import AlertCertBind from '../../components/alertCertBind';

import {tip, is_web, fetchLocal, saveLocal, encrypt, strMapToObj, objStrToMap} from '../../common/utils';
import { get, post } from '../../common/fetch';
// import console = require('console');
import call from '@jd/call/lib';
import sgmReport from '../../common/sgmUtil';

class MovieCardList extends PureComponent {
    constructor(props) {
        super(props);
        this.pwd = '';
        this.activeAndBindFlag = false;
        this.AlertCertBindContent = '';

        let seatsGroup = this.props.seatsGroup;
        let seatPriceList = JSON.parse(JSON.stringify(seatsGroup));

        this.state = {
            camilleExchange: false, //卡密兑换跳转
            userChoosedCardList: [], //  用电影卡时提单参数(自定义数据结构)，选择的电影卡列表
            cardList: [], //  包含当前场次可用/不可用卡
            cardNumber: '',
            isLoading: true,
            seatNum: props.seatNum, //  座位数
            restNum: props.seatNum, //  剩余次数
            show_isActive_confirm: false,
            showReason: false,
            afterActiveTime: '', // 激活后有效期
            activeExpiryTime: '', // 激活有效期
            isShowError: false,
            showPwdAlert: false,
            pwdError: false,
            pwdEmpty: false,
            Pwd: '',
            seatsGroup: seatsGroup,
            seatPriceList : seatPriceList,//已选择的座位价格信息
            partition: true,//区分分区
            selectCertificateMap: new Map()//用于存放所有已选择的兑换券数组Map，key是兑换券价格（或编号），value是List，List中可以存放多个座位
        };

        this.getMovieCardList = this.getMovieCardList.bind(this);
        this.exchangeCard = this.exchangeCard.bind(this);
        this.addMovieCard = this.addMovieCard.bind(this);
        this.textChange = this.textChange.bind(this);
        this.cardClick = this.cardClick.bind(this);
    }

    static defaultProps = {
        from: 2
    }

    render() {
        const { isLoading, cardList, cardNumber, show_isActive_confirm, showReason, activeExpiryTime, afterActiveTime, camilleExchange } = this.state;

        const { from } = this.props;
        const { isShowError, showPwdAlert, pwdError, Pwd, pwdEmpty } = this.state;

        if (isLoading) {
            return (
                <View style={ { flex: 1 } }>
                    {this.setTitle('京东兑换券')}
                    <Loading contentStyle={ { flex: 1 } } />
                </View>
            );
        }

        return (
            <View style={ { flex: 1 } }>
                {this.setTitle('京东兑换券')}

                <View style={ st.container }>

                    <ScrollView
                        showsVerticalScrollIndicator={ false }
                        keyboardShouldPersistTaps={ true }
                        contentContainerStyle={ st.content_wrap }
                        style={ st.scroll_view }
                        ref={ (scroll) => { this._scroll = scroll; } }
                    >
                        <View style={ [st.row_space_center, st.input_box] }>
                            <TextInput
                                placeholder="请输入兑换券码"
                                underlineColorAndroid="transparent"
                                placeholderTextColor="#bbb"
                                maxLength={ 20 }
                                style={ st.input }
                                onChangeText={ (cardPassWord) => this.textChange(cardPassWord) }
                                value={ cardNumber }
                                ref='textInput'
                            />

                            <Link
                                activeOpacity={ 0.5 }
                                onPress={ this.addMovieCard }
                            >
                                <LinearGradient
                                    colors={ ['#FF351A', '#FF6E17'] }
                                    start={ { x: 0, y: 0 } }
                                    end={ { x: 1, y: 0 } }
                                    style={ [st.row_center, st.add_btn_isweb] }
                                >
                                    <JDText style={ { color: '#fff', backgroundColor: 'transparent' } }>添加</JDText>
                                </LinearGradient>
                                {/* <View
                                    style={[st.row_center, st.add_btn]}>
                                    <JDText style={{color: '#fff', backgroundColor: 'transparent'}}>添加</JDText>
                                </View> */}
                            </Link>
                        </View>

                        <FlatList
                            data={ cardList }
                            keyExtractor={ item => item.certNum }
                            initialNumToRender={ 5 }
                            renderItem={ ({ item, index }) => {
                                return <MovieCardItem key={ index } from={ from } cardInfo={ item } cardIndex={ index } type={ item.canUse } cardClick={ this.cardClick } />;
                            } }
                            ListEmptyComponent={ () => {
                                return (
                                    <View style={ [st.row_center, st.dash_box] }>
                                        <JDImage style={ st.gray_img } source={ img.cardNotEnough } />
                                    </View>
                                );
                            } }
                        />

                    </ScrollView>
                    {/* 立即兑换 */}
                    {from == 1 &&
                        <TouchableOpacity
                            activeOpacity={ 0.5 }
                            style={ [st.bottom, { marginBottom: global.iphoneXMarginBottom }] }
                            onPress={ this.exchangeCard }
                        >
                            <View style={ [st.row_center, st.bottom_btn] }>
                                <JDText style={ { color: '#fff' } }>确定</JDText>
                            </View>
                        </TouchableOpacity>
                    }

                </View>

                {/* <JDConfirmDialog
                    show={show_isActive_confirm}
                    confirmText='确定'
                    cancelText='取消'
                    onCancel={this.close_isActive_confirm}
                    onConfirm={this.confirm_isActive_confirm}
                >
                    <View style={st.wrap_confirm_text}>
                        <JDText style={st.confirm_text}>{`该兑换券在${activeExpiryTime}前可激活并绑定，激活后有效期至${afterActiveTime}，是否确认激活并绑定?`}</JDText>
                    </View>
                </JDConfirmDialog> */}

                { <Alert
                    show={ show_isActive_confirm }
                    content={ `该兑换券在${activeExpiryTime}前可激活并绑定，激活后有效期至${afterActiveTime}，是否确认激活并绑定?` }
                    confirmText='确认绑定'
                    onConfirm={ this.confirm_isActive_confirm }
                    onCancel={ this.close_isActive_confirm }
                    isShowCancel={ true }
                    cancelText='取消'
                />}

                { <Alert
                    show={ showReason }
                    content={ `很遗憾，您的兑换券已过激活有效期（${activeExpiryTime}），激活失败。` }
                    confirmText='确定'
                    onConfirm={ this.closeShowReason }
                />}

                {showPwdAlert && <AlertCertBind
                    title='请输入卡号密码'
                    modalShow={ showPwdAlert }
                    // content={'该券在2020-01-02前可激活绑定，还有一些其他的文案展示啊'}
                    content={ this.AlertCertBindContent }
                    confirmText='确认绑定'
                    onConfirm={ this.iKnow }
                    onCancel={ this.closeCertBindAlert }
                    isShowCancel={ true }
                    cancelText='取消'
                    isShowError={ isShowError }
                    pwdError={ pwdError }
                    getPwd={ this.getPwd }
                    Pwd={ Pwd }
                    emailTxt={ this.pwd }
                    pwdEmpty={ pwdEmpty }
                />}

              { <Alert
                show={ camilleExchange }
                content={ `您输入的卡密为影豆卡，可以在【京东电影频道】–【我的】–【京东影豆卡】页面进行充值。` }
                confirmText='确认并跳转'
                onConfirm={ this.camilleExchangeGo }
              />}

            </View>
        );
    }

    componentDidFocus() {
        // JDLogin.isLogin().then(() => {
        //     this.getMovieCardList();
        // }, () => {
        //     JDLogin.doLogin().then(() => {
        //         this.getMovieCardList();
        //     });
        // }).catch( () => this.context.router.resetTo({ routeName: 'index' }) );
    }

    componentdidFocus() {
        if (is_web) {
            const { seatNum } = this.state;

            const { certInfo } = this.props;

            let hasSelectedNum = 0;

            if (certInfo.length > 0) {
                certInfo.forEach(item => {
                    hasSelectedNum += Number(item.verifyingTimes);
                });
            }
            this.setState({ restNum: seatNum - hasSelectedNum, certInfo });
        }
    }

    componentDidMount() {
        // if(!is_web){
        const { seatNum } = this.state;

        const { certInfo } = this.props;

        let hasSelectedNum = 0;

        if (certInfo.length > 0) {
            certInfo.forEach(item => {
                hasSelectedNum += Number(item.verifyingTimes);
            });
        }

        this.setState({ restNum: seatNum - hasSelectedNum });

        JDLogin.isLogin().then(() => {
            this.getMovieCardList();
        }, () => {
            JDLogin.doLogin().then(() => {
                this.getMovieCardList();
            });
        }).catch(() => {
            this.context.router.toIndex();
        });
    }


  // 开始跳转
  camilleExchangeGo = () => {
    // 跳去影豆页面
    this.context.router.toYingdouList();
    // 关闭弹窗
    this.setState({
      camilleExchange: false,
      cardNumber: ""
    })
  }

    closeCertBindAlert = () => {
        this.setState({
            showPwdAlert: false,
            pwdError: false,
            pwdEmpty: false
        });
        this.pwd = '';
    }

    iKnow = () => {
        if (this.pwd === '') {
            this.setState({
                pwdEmpty: true
            });
        } else {
            this.addMovieCard('1', 'pwd');
        }
    }

    getPwd = (pwd) => {
        // this.setState({
        //     getPwd: Pwd
        // })
        this.pwd = pwd;
    }

    closeShowReason = () => {
        this.setState({
            showReason: false
        });
    }

    close_isActive_confirm = () => {
        this.setState({
            show_isActive_confirm: false
        });
    }

    confirm_isActive_confirm = () => {
        this.addMovieCard('1');
        this.setState({ show_isActive_confirm: false });
    }

    textChange(cardPassWord) {
        if (!/^[A-Za-z0-9]+$/.test(cardPassWord)) {
            cardPassWord = cardPassWord.replace(/[^A-Za-z0-9]/g, '');
        }

        this.setState({
            cardNumber: cardPassWord
        });
        //     if (is_web) {
        //         document.title = '京东兑换券';
        //    }
    }

    // 获取卡列表
    getMovieCardList() {
        const { certInfo, from, promoId = 0, scheduledPlay = "0" } = this.props;

        const planId = this.props.planId || 0;

        const mobile = fetchLocal('savemobile') || 0;
        // let errCodeEnum = ['2016','2017','2018','2019','2020','2021','2022','2023','2024'];//查卡相关风控错误码，具体查看接口文档

        const { seatsGroup, seatPriceList, selectCertificateMap, partition } = this.state;
	      console.log('seatPriceList', seatPriceList, partition)
        let seat;
        if (partition && seatPriceList?.length) {    //将座位已价格从小到大排序
            seatPriceList.sort((a, b) => {
                return a["promotPrice"] - b["promotPrice"];
            });
            seat = seatPriceList[0]["meta"];
        }

        get('getCerts', {
					planId,
	        mobile: mobile || 0,
	        promoId,
	        seat,
	        scheduledPlay: +scheduledPlay
				})
          .then((res) => {
            // if(from == 1 && errCodeEnum.includes(res.errCode)){ //返回true命中风控
            //     !!res.errMsg&&tip(res.errMsg);
            // }

            const availableCardList = res?.data?.availableCerts || [];
            const currentUnavailableCardList = res?.data?.currentUnavailableCerts || [];

            this.props.dispatch({
                type: 'cert_num_change',
                cardNum: res.data.availableCerts ? res.data.availableCerts.length : 0
            });
            if (+from === 1 && (availableCardList.length > 0 || currentUnavailableCardList.length > 0)) {

		            //判断是否分区
		            if (partition) {        //分区了

				            availableCardList.forEach(item => {
						            item.useNum = 0;    //将每个可用兑换券使用次数赋值为0
						            let curlimitAmount = item.quota / 100;

						            //区分回填数据（已选择过兑换券再次进来）和第一次请求数据（没有选择过兑换券）
						            if(certInfo?.length) {  //回填数据
								            //设置兑换券可用状态

								            //处理回填数据，之前已选的
								            certInfo.forEach(infoItem => {
										            if (infoItem.certNum === item.certNum) {
												            //将已选择的兑换券与兑换券列表编号比对，如果有之前选择的，将之前使用的次数赋值给已选次数
												            item.useNum = infoItem.verifyingTimes;
												            //对应的座位编号字符串 格式 no1 | no2 | no3
												            let seatListStr = infoItem.seatList;
												            let promoVerifyingTimes = infoItem.promoVerifyingTimes;
												            item["seatList"] = seatListStr;
												            item["promoVerifyingTimes"] = promoVerifyingTimes;
												            let certificateToSeatList = [];
												            if(seatPriceList?.length) {
														            for (let i = seatPriceList.length - 1; i >= 0; i--) {
																            let seatInfo = seatPriceList[i];
																            if (!!seatListStr && seatListStr.indexOf("|") !== -1) {
																		            //分割后的座位编号数组
																		            let seatNoList = seatListStr.split("|");
																		            seatNoList.forEach(seatNo => {
																				            if (seatNo === seatInfo.meta) {
																						            certificateToSeatList.push(seatInfo);
																						            seatPriceList.splice(i, 1);
																				            }
																		            })
																            } else {     //只有一个编号
																		            if (seatListStr === seatInfo.meta) {
																				            certificateToSeatList.push(seatInfo);
																				            seatPriceList.splice(i, 1);
																		            }
																            }
														            }
														            selectCertificateMap.set(infoItem.certNum, certificateToSeatList);
												            }
												            //当前兑换券之前已选的，可用
												            item.canUse = 1;
										            }
								            });

						            } else {    //非回填数据，第一次请求加载
						            		if (seatPriceList.length) {
										            let minPrice = seatPriceList[0].promotPrice;//默认第一个座位的价格最低
										            seatPriceList.forEach(item => {
												            if (item.promotPrice < minPrice) {
														            minPrice = item.promotPrice;
												            }
										            });
										            if (curlimitAmount < minPrice / 100) {
												            item.canUse = 0;
										            } else {
												            item.canUse = 1;
										            }
								            }
						            }

				            });

				            //处理回填
				            if (certInfo?.length) {
						            availableCardList.forEach(item => {
								            let curlimitAmount = item.quota / 100;
								            let hasOwn = selectCertificateMap.has(item.certNum);
								            if (!hasOwn) {   //之前未选择的兑换券
										            // 两种情况，显示高亮和置灰状态
										            // 1.座位数组中如果都已兑换，则当前兑换券与座位最高价作对比
										            // 2.座位数组中有未兑换的座位，则与当前座位数组中座位价格最低的去比对
										            if (seatPriceList?.length) {
												            seatPriceList.sort((a, b) => {
														            return a["promotPrice"] - b["promotPrice"];
												            });
												            //当前座位最低价格
												            let minSeatPrice = seatPriceList[0].promotPrice;
												            if (curlimitAmount < minSeatPrice / 100) {
														            item.canUse = 0;
												            } else {
														            item.canUse = 1;
												            }
										            } else {
												            //当前兑换券需要判断是否大于最大金额
												            seatsGroup.sort((a, b) => {
														            return a["promotPrice"] - b["promotPrice"];
												            });
												            //取最大价格的座位
												            let maxSeatPrice = seatsGroup[seatsGroup.length - 1].promotPrice;
												            if (curlimitAmount < maxSeatPrice / 100) {
														            item.canUse = 0;
												            } else {
														            item.canUse = 1;
												            }
										            }
								            }
						            });
				            }

		            } else {    //未分区
				            availableCardList.forEach(item => {
						            item.useNum = 0;
						            item.canUse = 1;

						            // 回填
						            certInfo?.length && certInfo.forEach(infoItem => {
								            if (infoItem.certNum === item.certNum) {
										            item.useNum = infoItem.verifyingTimes;
								            }
						            });
				            });
		            }
		            currentUnavailableCardList.forEach(item => {
				            item.canUse = 0;
		            });
            }
            if (from == 2) {
                availableCardList.forEach(function(item) {
                    item.canUse = 1;
                });
            }
            const cardList = availableCardList.concat(currentUnavailableCardList);
            this.setState({ cardList, userChoosedCardList: certInfo, isLoading: false });
        }).catch((err) => {
            console.log('卡列表获取失败', err);
            this.setState({ cardList: [], isLoading: false });
        });
    }

    // 绑卡
    addMovieCard(bool, next) {
        this.refs.textInput.refs.input.blur();

        const activeAndBindFlag = bool === '1' ? 1 : 0;

        // if(this.activeAndBindFlag){
        //     activeAndBindFlag = 1;
        // }
        const certPwd = next === 'pwd' ? this.pwd : null;

        const { cardNumber } = this.state;

        const planId = this.props.planId || 0;

        const { from, promoId = 0 } = this.props;

        const cardList = JSON.parse(JSON.stringify(this.state.cardList));

        if (!cardNumber.trim()) {
            tip('请输入兑换码');
            this.setState({ cardNumber: '' });

            return;
        }

        if (!/^[A-Za-z0-9]+$/.test(cardNumber)) {
            tip('兑换码已被绑定或者兑换码无效');
            this.setState({ cardNumber: '' });

            return;
        }

        post('bindCert', { certNum: cardNumber, planId, promoId, activeAndBindFlag, certPwd }).then(res => {
            if (res.errCode == 2006) {
                const cardItem = res.data;

                if (from == 1 && cardItem.currentAvailable) { //  cardItem.currentAvailable  接口返回当前场次此卡是否可用
                    cardItem.useNum = 0;
                    cardItem.canUse = 1;

                    cardList.unshift(cardItem);
                }

                if (from == 1 && !cardItem.currentAvailable) {
                    cardItem.canUse = 0;

                    const index = cardList.findIndex(ele => !ele.canUse);

                    index >= 0 ? cardList.splice(index, 0, cardItem) : cardList.push(cardItem);
                }

                if (from == 2) {
                    cardItem.canUse = 1;
                    cardList.unshift(cardItem);
                }
                this.closeCertBindAlert();
                tip('绑卡成功');
                this.setState({ cardList, cardNumber: '' });
            }

            if (res.errCode != '2006') {
                // let msg = {
                //     2000: '请输入兑换券码',
                //     2001: '输入的兑换码无效',
                //     2002: '兑换码已被绑定',
                //     2003: '请休息一会，10分钟后再试',
                //     2004: '请休息一会，30分钟后再试',
                //     2005: '请休息一会，明日再试',
                //     2109: '兑换券绑定数量达到上限'
                // }

                // tip(msg[res.errCode]);
                if (res.errCode === '2012' || res.errCode === 2012) {
                    this.AlertCertBindContent = '';
                    this.setState({
                        showPwdAlert: true
                    });
                } else if (res.errCode === '2013' || res.errCode === 2013) {
                    this.activeAndBindFlag = true;
                    this.AlertCertBindContent = `该兑换券在${res.data.activeExpiryTime}前可激活并绑定，激活后有效期至${res.data.afterActiveTime}，是否确认激活并绑定?`;
                    this.setState({
                        showPwdAlert: true,
                        activeExpiryTime: res.data.activeExpiryTime,
                        afterActiveTime: res.data.afterActiveTime
                    });
                } else if (res.errCode === '2014' || res.errCode === 2014) {
                    this.setState({
                        pwdError: true,
                        pwdEmpty: false
                    });
                } else if (res.errCode === '2009' && res.data.isActive) {
                    this.setState({
                        show_isActive_confirm: true,
                        activeExpiryTime: res.data.activeExpiryTime,
                        afterActiveTime: res.data.afterActiveTime
                    });
                } else if (res.errCode === '2008') {
                    this.setState({
                        showReason: true,
                        activeExpiryTime: res.data.activeExpiryTime,
                        afterActiveTime: res.data.afterActiveTime // 样式未剧中
                    });
                } else if(+res.errCode === 2601) {
                  // 影豆卡
                  // 弹出菜单!
                  this.setState({
                    camilleExchange: true
                  })
                } else {
                    tip(res.errMsg);
                    this.setState({ cardNumber: '' });
                }
            }

            if (res.errCode === '2015') { // 本次风控需求新增
                tip('当前账号存在风险，无法添加卡券');
            }
        });

        if(!cardNumber || !planId || !promoId){
            sgmReport('1001', {function_id: 'bindCert',message:'缺少参数certNum/planId/promoId'}, 3)
        }
    }

    // 点击卡
    cardClick(index, type) {
        const cardList = JSON.parse(JSON.stringify(this.state.cardList));

        let { restNum, seatNum, seatPriceList, selectCertificateMap, partition} = this.state;
        const { from, dispatch } = this.props;

        const certInfo = [];    //certInfo存放所有已使用兑换券的数组

        let allSelectedNum = 0; //  选中次数
        const cardInfo = cardList[index];

        //兑换券的限兑金额
        let limitAmount = cardInfo.quota / 100;
		    //判断是否分区
		    if (partition && seatPriceList?.length) {
				    // 规则描述 4张40的座位， 10张100的兑换券，1张40的兑换券，先选择100的兑换券直接使用4次，想要使用40的兑换券，
				    // 就提示兑换次数已购，想要使用40的兑换券，就得将100的兑换券反选
				    // 先对seatPriceList进行按座位价格从小到大排序，如： [1,2,3,4]
				    seatPriceList.sort((a,b) => {
						    return a["promotPrice"] - b["promotPrice"];
				    });
		    }
        if (from == 1) {
            if (cardInfo.canUse) {
                if (cardInfo.useNum) { //  反选，取消选择
                    cardInfo.useNum = 0; //反选后将选择的次数置为0
		                //判断是否分区
		                if (partition) {    //分区了
				                cardInfo["seatList"] = "";//将该兑换券对应的兑换座位信息清空
				                if (selectCertificateMap.has(cardInfo.certNum)) {
						                //将座位释放放回copySeatPriceList中
						                selectCertificateMap.forEach(function (value, key) {
								                if (key === cardInfo.certNum) {
										                value.forEach(item => {
												                seatPriceList.push(item);
										                })
								                }
						                })
						                // 这样删除 如果两张45元的兑换券 会不会都删除呢？
						                selectCertificateMap.delete(cardInfo.certNum);//根据该兑换券编号（key）从已选择的所有兑换券Map中移除该兑换券
						                seatPriceList.sort((a,b) => {
								                return a["promotPrice"] - b["promotPrice"];
						                });
				                }
		                }

                } else { //  没选选上
                    if (!restNum) {
                        tip('已够兑换次数');
                        return;
                    }


		                //判断是否分区
		                if (partition) {    //分区了
				                //从大到小的座位价格遍历，小于等于兑换券的座位优先使用兑换券，直到该兑换券剩余兑换次数用完为止
				                let certificateToSeatList = [];//一个兑换券可以对应多个座位
				                for (let i = seatPriceList.length - 1; i >= 0; i--) {
						                let seatPrice = seatPriceList[i].price;
						                if (seatPrice / 100 <= limitAmount && cardInfo.useNum < cardInfo.leftTimes) {
								                //该兑换券的已选次数加1
								                ++cardInfo.useNum;
								                //将该兑换券对应的座位放入list
								                certificateToSeatList.push(seatPriceList[i]);
								                seatPriceList.splice(i, 1);
						                }
				                }

				                //将座位价格与该座位使用的兑换券价格以键值对形式放到Map中，其中座位价格为Key,使用的兑换券价格为Value
				                if (certificateToSeatList.length) {
						                selectCertificateMap.set(cardInfo.certNum, certificateToSeatList);//相同价格的座位，可能会保存同一个座位，区分这两个价格相同的座位，使用兑换券编号当Key
						                // 将已选择的兑换券按照接口需要拼接
						                let seatList = "";
						                let promoVerifyingTimes = 0;//该兑换券所对应的所有座位中有优惠的座位个数
						                for (let i = 0; i < certificateToSeatList.length; i++) {
								                let item = certificateToSeatList[i];
								                if (i) {
										                seatList = seatList.concat("|", item.meta);
								                } else {
										                seatList = seatList.concat(item.meta);
								                }
								                if (item?.actId?.length) { //actId不为空，则有优惠
										                promoVerifyingTimes++;
								                }
						                }
						                cardInfo["seatList"] = seatList;
						                cardInfo["promoVerifyingTimes"] = promoVerifyingTimes;
				                }
		                }
		                else {    //未分区
				                if (cardInfo.leftTimes >= restNum) {
						                // restNum是剩余要兑换的次数
						                cardInfo.useNum = restNum;  //赋值该兑换券的使用次数，如果剩余次数大于选择的座位票数，直接将剩余要兑换座位的次数赋值给使用次数，勾选后展示
				                } else {
						                cardInfo.useNum = cardInfo.leftTimes;   //可兑换的次数不够，将剩余次数使用，勾选后展示
				                }
		                }

                }

                cardList[index] = cardInfo;

		            //判断是否分区
		            if (partition) {    //分区了

				            let minPrice;   //有可能为空
				            // 重新取出剩余座位的最低价格，seatPriceList可能为[]，即已兑换完座位
				            if (seatPriceList?.length) {
						            // 选择或反选后，判断剩余兑换券是否满足可使用状态
						            minPrice = seatPriceList[0]?.promotPrice;//默认第一个座位的价格最低
						            seatPriceList?.forEach(item => {
								            if (item.promotPrice < minPrice) {
										            minPrice = item.promotPrice;
								            }
						            });
				            }

				            //可能多选兑换券，遍历数组，将所有选中的兑换券放到certInfo中
				            for (let i = 0; i < cardList.length; i++) {
						            let item = cardList[i];
						            let curlimitAmount = item.quota / 100;
						            let userNum = !!item.useNum;
						            if(!!minPrice) {
								            if (index !== i && !userNum && curlimitAmount < minPrice / 100) {
										            item.canUse = 0;
								            } else {
										            item.canUse = 1;
								            }
						            }

						            if (item.useNum) {      //前面接口请求下来后每个可用兑换券都默认赋值了使用次数为0
								            certInfo.push({         //将所有可用的兑换券（即有剩余次数的兑换券）放到certInfo本地数组中
										            certNum: item.certNum,
										            verifyingTimes: item.useNum,
										            certPwd: item.certPwd,
										            seatList: item.seatList,    //该兑换券兑换了哪些座位的数组
										            quota: item.quota,   //该兑换券的限兑金额,
										            promoVerifyingTimes: item.promoVerifyingTimes,   //该兑换券的限兑金额,
								            });
						            }
				            }
		            }
		            else {    //未分区
				            cardList.forEach(item => {
						            if (item.useNum) {
								            certInfo.push({ // certInfo存放所有已使用兑换券的数组
										            certNum: item.certNum,
										            verifyingTimes: item.useNum,    //兑换券的使用次数
										            certPwd: item.certPwd,
										            quota: item.quota   //该兑换券的限兑金额
								            });
						            }
				            });
		            }

                //遍历所有选中的兑换券数组，将所有选择的次数累加
                certInfo.forEach(item => {
                    allSelectedNum += item.verifyingTimes;
                });
	              console.log('certInfo66666666', certInfo)
                this.setState({
	                cardList,
	                userChoosedCardList: certInfo,
	                restNum: seatNum - allSelectedNum
                });
            } else {
                cardInfo.certTips ? tip(cardInfo.certTips) : tip('兑换券此订单不可用');
            }
        }
        if (from == 2) {
            const { movieCertRuleId } = cardInfo;

            dispatch({
                type: 'card_info_change',
                cardInfo
            });
            // this.context.router.toMovieCardInfo({ movieCertRuleId,canUse:1 });
            cardInfo.certTips ? tip(cardInfo.certTips) : this.context.router.toMovieCardInfo({ movieCertRuleId, canUse: 1 });
            saveLocal('CardInfo', cardInfo);
        }
        console.log('cardInfo', cardInfo, selectCertificateMap)
    }

    // 立即兑换
    exchangeCard() {
        if (this.lock) {
            return;
        }

        const { userChoosedCardList, selectCertificateMap} = this.state;

        const { dispatch } = this.props;

        this.lock = true;

		    console.log('userChoosedCardList', userChoosedCardList)

        dispatch({
            type: 'cert_info_change',
            certInfo: userChoosedCardList   //存放所有已使用兑换券的数组
        });
	      saveLocal('certInfo', userChoosedCardList)
        // map 转数组
        const selectCertificateMapObj = strMapToObj(selectCertificateMap);
        dispatch({
            type: 'select_certificate_map',
            selectCertificateMap: selectCertificateMapObj   //分区的 所有使用兑换券的Map，key是兑换券编号，Value是数组(因为一张兑换券有可能有多次使用次数，可以兑换多个座位)
        });
	      saveLocal('selectCertificateMap', selectCertificateMapObj)

        setTimeout(() => {
           this.context.router.pop();
	         call.event.emit('order');
        }, 400);
    }

    setTitle = (title) => {
        document.title = title;
    }
}

MovieCardList.contextTypes = {
    router: PropTypes.object
};

const img = {
    cardNotEnough: require('../../img/movie-card/card_not_enough.png')
};

const select = (state) => {
    const { certInfo, selectCertificateMap } = state.movieCard;
    const { seatsGroup } = state?.seat || [];
		const seatsGroupCache = fetchLocal('seatsGroup');
		const selectCertificateMapCache = fetchLocal('selectCertificateMap');
		console.log('seatsGroup', state)
    return {
        certInfo,
        seatsGroup: seatsGroup || seatsGroupCache,
		    selectCertificateMap: selectCertificateMap || selectCertificateMapCache
    };
};

export default connect(select, null, null, { withRef: true })(MovieCardList);
